import { render, staticRenderFns } from "./proPoint.vue?vue&type=template&id=20eea87e&scoped=true&"
import script from "./proPoint.vue?vue&type=script&lang=js&"
export * from "./proPoint.vue?vue&type=script&lang=js&"
import style0 from "./proPoint.vue?vue&type=style&index=0&id=20eea87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eea87e",
  null
  
)

export default component.exports